/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import memoize from 'lodash/memoize';
import 'react-day-picker/dist/style.css';
import { stringToBoolean } from '../../utilities/conversionUtility';
import { detectIOS } from '../../utilities/helperUtility';
import DatePicker from '../DatePicker/DatePicker';
import {
  StyledDatePicker,
  StyledLegendBackground,
  StyledRectangleWhite,
  StyledLegendWrapper,
  StyledLegendSection,
  StyledText,
} from './RentalDatePicker.style';

const now = new Date();

export default class RentalDatePicker extends DatePicker {
  constructor(props) {
    super(props);

    this.debounceDayClick = debounce(this.debounceDayClick, detectIOS() ? 500 : 0);
    this.onDayClick = this.onDayClick.bind(this);
    this.getTooltips = memoize(this.getTooltips).bind(this);
  }

  debounceDayClick(day, modifiers) {
    const { onDayClick } = this.props;

    if (!modifiers.disabled) {
      onDayClick(day, modifiers);
    }
  }

  onDayClick(day, modifiers = {}) {
    this.debounceDayClick(day, modifiers);
  }

  getTooltips() {
    const { messages } = this.props;

    return ({
      nonAvailable: messages.message_unavailable || 'Unavailable',
      bookedDates: messages.message_booked_out || 'Booked out',
      blackoutsOverlap: messages.message_blacked_out || 'Blacked out',
    });
  }

  render() {
    const {
      enteredTo,
      from,
      isDisableCalendar,
      modifiers,
      modifiersClassNames,
      setting,
      styled,
      translation,
      shopBeginningOfWeek,
    } = this.props;
    const { padding, fontSize, localization } = this.state;
    const selectedDays = { from, to: enteredTo };
    const customStyle = { padding, fontSize };
    const tooltips = this.getTooltips();
    const weekStartsOn = parseInt(shopBeginningOfWeek);

    return (
      <div className="rental">
        <StyledDatePicker
          mode="range"
          showOutsideDays
          className="Range"
          modifiers={modifiers}
          modifiersClassNames={modifiersClassNames}
          selected={selectedDays}
          weekStartsOn={isNaN(weekStartsOn) ? null : weekStartsOn}
          isDisableCalendar={isDisableCalendar}
          onDayClick={this.onDayClick}
          onMonthChange={this.onMonthChange}
          highlightColor={setting.highlight_color}
          onDayMouseEnter={this.handleDayMouseEnter}
          onDayMouseLeave={this.handleDayMouseLeave}
          locale={localization}
          fromMonth={now}
          month={this.props.month}
          styled={styled}
          customStyle={customStyle}
          tooltips={tooltips}
        />

        {stringToBoolean(setting.display_legend) === true && (
          <StyledLegendWrapper>
            <StyledLegendSection>
              <StyledLegendBackground backgroundColor={styled.selector?.active.backgroundColor} start>
                <StyledRectangleWhite start />
              </StyledLegendBackground>
              <StyledText dangerouslySetInnerHTML={{ __html: translation.key('legendStartText') }} />
            </StyledLegendSection>

            <StyledLegendSection>
              <StyledText dangerouslySetInnerHTML={{ __html: translation.key('legendEndText') }} end />
              <StyledLegendBackground backgroundColor={styled.selector?.active.backgroundColor} end>
                <StyledRectangleWhite end />
              </StyledLegendBackground>
            </StyledLegendSection>
          </StyledLegendWrapper>
        )}
      </div>
    );
  }
}

RentalDatePicker.propTypes = {
  setting: PropTypes.object,
  isDisableCalendar: PropTypes.bool,
};
